import React, { useState, useMemo, useEffect, useCallback } from 'react';

var Vk = "data:image/svg+xml,%3Csvg%20width%3D%2236%22%20height%3D%2236%22%20viewBox%3D%220%200%2036%2036%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_1378_2207%29%22%3E%3Cpath%20d%3D%22M18%2036C27.9411%2036%2036%2027.9411%2036%2018C36%208.05887%2027.9411%200%2018%200C8.05887%200%200%208.05887%200%2018C0%2027.9411%208.05887%2036%2018%2036Z%22%20fill%3D%22%23718096%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.4333%2012.9568C14.7481%2013.1809%2014.8907%2013.883%2014.9392%2015.2824C14.9807%2016.4798%2015.0239%2017.8145%2014.4993%2018.6932C13.0862%2018.8057%2011.6216%2015.5494%2011.045%2014.3939C10.4608%2013.2226%2010.6609%2012.4897%208.97824%2012.5326C8.10647%2012.5547%205.89549%2012.3097%205.3809%2012.9075C4.95694%2013.7871%209.25574%2020.5837%2010.0495%2021.6817C10.9255%2022.8933%2012.1844%2024.1131%2013.66%2024.8942C15.146%2025.681%2017.8466%2026.2191%2019.5015%2025.5605C19.7234%2024.6164%2019.5831%2022.5431%2020.7604%2022.6502C22.1802%2022.7792%2022.58%2025.9783%2025.8951%2025.8644C27.2638%2025.8173%2028.7879%2026.0416%2029.7026%2025.413C29.8754%2024.246%2028.5587%2022.8905%2027.8174%2022.1508C26.7857%2021.1215%2025.3928%2020.4219%2025.9425%2019.2728C26.6426%2017.81%2030.0076%2014.7362%2029.7026%2012.7768C28.8328%2012.4173%2025.4546%2012.4692%2024.3233%2012.6534C24.0056%2012.811%2021.4187%2019.097%2020.1246%2018.6887C18.7621%2017.554%2020.4291%2013.4666%2019.355%2012.3784C18.8457%2011.8624%2013.9316%2011.3653%2013.4333%2012.9565V12.9568Z%22%20fill%3D%22%239FB4C0%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.4333%2012.9568C14.7481%2013.1809%2014.8907%2013.883%2014.9392%2015.2824C14.9807%2016.4798%2015.0239%2017.8145%2014.4993%2018.6932C13.0862%2018.8057%2011.6216%2015.5494%2011.045%2014.3939C10.4608%2013.2226%2010.6609%2012.4897%208.97824%2012.5326C8.10647%2012.5547%205.89549%2012.3097%205.3809%2012.9075C4.95694%2013.7871%209.25574%2020.5837%2010.0495%2021.6817C10.9255%2022.8933%2012.1844%2024.1131%2013.66%2024.8942C15.146%2025.681%2017.8466%2026.2191%2019.5015%2025.5605C19.7234%2024.6164%2019.5831%2022.5431%2020.7604%2022.6502C22.1802%2022.7792%2022.58%2025.9783%2025.8951%2025.8644C27.2638%2025.8173%2028.7879%2026.0416%2029.7026%2025.413C29.8754%2024.246%2028.5587%2022.8905%2027.8174%2022.1508C26.7857%2021.1215%2025.3928%2020.4219%2025.9425%2019.2728C26.6426%2017.81%2030.0076%2014.7362%2029.7026%2012.7768C28.8328%2012.4173%2025.4546%2012.4692%2024.3233%2012.6534C24.0056%2012.811%2021.4187%2019.097%2020.1246%2018.6887C18.7621%2017.554%2020.4291%2013.4666%2019.355%2012.3784C18.8457%2011.8624%2013.9316%2011.3653%2013.4333%2012.9565V12.9568Z%22%20fill%3D%22white%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_1378_2207%22%3E%3Crect%20width%3D%2236%22%20height%3D%2236%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var Ok = "data:image/svg+xml,%3Csvg%20width%3D%2236%22%20height%3D%2236%22%20viewBox%3D%220%200%2036%2036%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M18%2036C27.9411%2036%2036%2027.9411%2036%2018C36%208.05887%2027.9411%200%2018%200C8.05887%200%200%208.05887%200%2018C0%2027.9411%208.05887%2036%2018%2036Z%22%20fill%3D%22%23718096%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.1388%2018.6081C13.0183%2018.6916%2012.7872%2018.6897%2012.4512%2019.0102C12.1132%2019.3307%2012.1171%2019.554%2012.0064%2019.7017C11.9539%2020.0707%2011.9461%2020.2009%2011.9869%2020.5952C12.0102%2020.6107%2012.1656%2020.9933%2012.2181%2021.0749C12.3132%2021.2206%2012.4492%2021.3624%2012.5988%2021.4712C13.0902%2021.8363%2014.0808%2022.287%2014.6849%2022.4948C14.8578%2022.555%2015.0831%2022.6288%2015.2734%2022.6832C15.4638%2022.7376%2015.7532%2022.7687%2015.895%2022.8891L14.7276%2024.0487C14.3294%2024.4488%2013.9604%2024.8159%2013.5603%2025.2141C13.2611%2025.5113%2012.6648%2026.0202%2012.4764%2026.4631C11.9248%2027.7625%2013.2029%2029.0872%2014.5276%2028.5997C15.2909%2028.318%2017.612%2025.5132%2018.1384%2025.2277C18.9018%2025.8939%2021.0326%2028.3433%2021.7473%2028.6035C22.4699%2028.8677%2023.1245%2028.5744%2023.4838%2028.184C23.8665%2027.7703%2024.0627%2027.106%2023.7791%2026.4417C23.5945%2026.0085%2022.9944%2025.4938%2022.6933%2025.1927C21.9066%2024.408%2021.1258%2023.6447%2020.3605%2022.8561C20.848%2022.7026%2021.2851%2022.6036%2021.7493%2022.4307C22.4311%2022.1762%2023.6703%2021.644%2024.051%2021.0594C24.5094%2020.3582%2024.2103%2019.8415%2024.2394%2019.5735L24.0355%2019.2724C23.5693%2018.5576%2022.6098%2018.3401%2021.8134%2018.8237C20.0167%2019.9134%2017.8898%2020.1873%2015.8658%2019.4958C14.2362%2018.9383%2014.4926%2018.4683%2013.1368%2018.6042L13.1388%2018.6081Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M17.8506%2010.6089C19.1811%2010.3971%2020.2145%2011.4363%2020.3951%2012.5512C20.6146%2013.9051%2019.5716%2014.9481%2018.4625%2015.1268C17.1047%2015.3444%2016.0384%2014.3091%2015.8752%2013.1845C15.6713%2011.7879%2016.6794%2010.7973%2017.8526%2010.6108L17.8506%2010.6089ZM16.1802%207.69725C15.9121%207.90314%2015.0419%208.04299%2013.9523%209.27834C12.041%2011.4441%2012.2294%2014.8996%2014.3272%2016.8478C14.4437%2016.9546%2014.7739%2017.209%2014.8322%2017.3081C15.0478%2017.3877%2015.2148%2017.5412%2015.4207%2017.6558C16.9688%2018.5299%2018.8937%2018.6114%2020.4592%2017.8597C25.3521%2015.5095%2024.2876%208.56549%2019.3268%207.48748C17.9089%207.17864%2017.3398%207.43697%2016.1821%207.69725H16.1802Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$7 = ".SocialIcons-module_socialMediaIcons__mLDzV {\n  display: flex;\n  align-items: center;\n}";
var s$6 = {"socialMediaIcons":"SocialIcons-module_socialMediaIcons__mLDzV"};
styleInject(css_248z$7);

var SocialMediaIcons = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b;
    var links = [
        // {
        //   alt: "Instagram",
        //   link: "https://www.instagram.com/zapiskvrachy/",
        //   icon: Instagram,
        // },
        { alt: "VK", link: "https://vk.com/zapiskvrachuonline", icon: Vk },
        { alt: "OK", link: "https://ok.ru/zapiskvrachy", icon: Ok },
        // {
        //   alt: "Facebook",
        //   link: "https://www.facebook.com/zapiskvrachy",
        //   icon: Facebook,
        // },
    ];
    return (React.createElement(React.Fragment, null, links.map(function (item) { return (React.createElement("div", { className: s$6.socialMediaIcons, key: item.link },
        React.createElement("a", { onClick: onClick, href: item.link },
            React.createElement("img", { src: item.icon, alt: item.alt })))); })));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

// eslint-disable-next-line import/no-mutable-exports
var config = {
    isStageServer: window.location.hostname.includes("eltc.ru") ||
        !window.location.hostname.includes("onlinezdrav"),
    isSPA: !!window.isSPA,
};
config = __assign(__assign({}, config), { seoPartUrl: config.isStageServer
        ? "https://onlinezdrav-test.eltc.ru"
        : "https://onlinezdrav.ru", reactivePartUrl: config.isStageServer
        ? "https://app.onlinezdrav-test.eltc.ru"
        : "https://app.onlinezdrav.ru", policyUrl: "https://vrach.f.x.eltc.ru/doctor/zapis_k_vrachy.pdf", yandexGeocoderApiKey: "b743d7b3-e9d9-4cf2-8126-3aa7127d5e46", sentryUrl: "https://77050d7a80064992a2baec1c57b09cdb@sentry.eltc.ru/162" });
config.api = {
    tokenKey: "access_token",
    tokenValue: "D55C9523-6D68-5E04-E053-0100007F375E",
    endpoints: {
        vrach: "https://api.goodline.info/dev/mobile/digitalcity/v6/mo",
        egis: "https://api.goodline.info/dev/mobile/mo-egis/v1",
        onlinezdrav: "".concat(config.isSPA ? config.seoPartUrl : "", "/api/v1"),
    },
};
var config$1 = config;

var css_248z$6 = ".Logo-module_logo__--Pof {\n  font-family: \"Fira Sans\", sans-serif !important;\n  display: flex;\n  align-items: center;\n  color: #0f334d;\n  font-size: 24px;\n  font-weight: 700;\n  column-gap: 8px;\n}\n@media (min-width: 768px) {\n  .Logo-module_logo__--Pof {\n    font-size: 28px;\n    column-gap: 10px;\n  }\n}\n.Logo-module_logo__--Pof svg {\n  width: 32px;\n  height: 32px;\n}\n@media (min-width: 768px) {\n  .Logo-module_logo__--Pof svg {\n    width: 36px;\n    height: 36px;\n  }\n}";
var s$5 = {"logo":"Logo-module_logo__--Pof"};
styleInject(css_248z$6);

var Logo = function (_a) {
    var onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (React.createElement("a", { onClick: onClick, href: config$1.seoPartUrl, className: "".concat(s$5.logo, " ").concat(className) },
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 51 51", fill: "none" },
            React.createElement("circle", { cx: "25.5", cy: "25.5", r: "21.5", stroke: "#FA5773", strokeWidth: "8" }),
            React.createElement("rect", { x: "12.75", y: "30.1362", width: "9.27273", height: "25.5", transform: "rotate(-90 12.75 30.1362)", fill: "#FA5773" }),
            React.createElement("rect", { x: "20.8637", y: "12.75", width: "9.27273", height: "25.5", fill: "#FA5773" })),
        React.createElement("span", null, "\u041E\u043D\u043B\u0430\u0439\u043D\u0417\u0434\u0440\u0430\u0432")));
};

/* eslint-disable no-useless-escape */

const getPageTitle = () => {
  const { pathname } = window.location;

  switch (true) {
    case /\/([^\/]+)\/spisok-mo\/([^\/]+)\/([^\/]+)\/?$/.test(pathname):
      return "Список департаментов выбранного типа";
    case /\/([^\/]+)\/spisok-mo\/([^\/]+)\/?$/.test(pathname):
      return "Список МО выбранного типа";
    case /\/([^\/]+)\/spisok-mo\/?$/.test(pathname):
      return "Список всех МУ";
    case /\/([^\/]+)\/mo\/([^\/]+)\/?$/.test(pathname):
      return "Страница МО";
    case /\/([^\/]+)\/dep\/([^\/]+)\/?$/.test(pathname):
      return "Страница департамента";
    case /\/help\/?$/.test(pathname):
      return "Страница помощи";
    case /\/about\/?$/.test(pathname):
      return "Страница ОС";
    default:
      return "";
  }
};

const logEvent = (event, props = {}) => {
  if (!window.amplitude) {
    console.warn("onlinezdrav-ui не видит Амплитуду");
  }

  window.amplitude.logEvent(event, {
    Часть: window.isSPA ? "Прод" : "Натив",
    Регион: JSON.parse(localStorage.getItem("currentCity") ?? "")?.area_name,
    Город: JSON.parse(localStorage.getItem("currentCity") ?? "")?.name,
    "Страница пользователя": getPageTitle(),
    ...props,
  });
};

/* eslint-disable import/prefer-default-export */
var logLinkClick$1 = function (event) {
    logEvent(event, {});
};

var css_248z$5 = ".Footer-module_footer__smP7p {\n  padding-top: 30px;\n  padding-bottom: 80px;\n  background: #f7fafc;\n}\n@media (min-width: 768px) {\n  .Footer-module_footer__smP7p {\n    padding-bottom: 40px;\n  }\n}\n.Footer-module_footer__container__gjEa- {\n  grid-column: 1/-1;\n  display: grid;\n  grid-template-columns: auto;\n  grid-template-rows: auto auto;\n  grid-template-areas: \"title\" \"notes\";\n}\n@media (min-width: 768px) {\n  .Footer-module_footer__container__gjEa- {\n    grid-template-columns: 50% 50%;\n    grid-template-rows: auto auto auto;\n    grid-template-areas: \"logo links\" \"title links\" \"notes notes\";\n  }\n}\n@media (min-width: 1440px) {\n  .Footer-module_footer__container__gjEa- {\n    grid-template-columns: 1fr 3fr;\n    grid-template-rows: auto auto auto;\n    grid-template-areas: \"logo logo\" \"title links\" \"notes notes\";\n  }\n}\n.Footer-module_footer__logoCol__R4QA6 {\n  grid-area: logo;\n  margin-bottom: 20px;\n}\n.Footer-module_footer__logo__rQHjg {\n  display: none;\n}\n@media (min-width: 768px) {\n  .Footer-module_footer__logo__rQHjg {\n    display: flex;\n    align-items: center;\n    color: #0f334d;\n    font-size: 28px;\n    font-weight: 700;\n    column-gap: 10px;\n  }\n}\n.Footer-module_footer__titleCol__10X1- {\n  grid-area: title;\n}\n.Footer-module_footer__title__4q4k8 {\n  font-weight: 700;\n  color: #2d3748;\n}\n.Footer-module_footer__separator__jIkdN {\n  width: 100%;\n  border-top: 1px solid #cbd5e0;\n  margin: 14px 0px;\n}\n@media (min-width: 768px) {\n  .Footer-module_footer__separator__jIkdN {\n    margin: 22px 0px;\n  }\n}\n.Footer-module_footer__linksCol__X8dDz {\n  display: none;\n  grid-area: links;\n}\n@media (min-width: 768px) {\n  .Footer-module_footer__linksCol__X8dDz {\n    display: block;\n    margin-left: 60px;\n  }\n}\n.Footer-module_footer__linksList__sgDTK {\n  display: flex;\n}\n@media (min-width: 768px) {\n  .Footer-module_footer__linksList__sgDTK {\n    margin-bottom: 16px;\n    flex-direction: column;\n    row-gap: 8px;\n  }\n}\n@media (min-width: 1440px) {\n  .Footer-module_footer__linksList__sgDTK {\n    flex-direction: row;\n    column-gap: 18px;\n    justify-content: space-between;\n    margin-bottom: 22px;\n  }\n}\n.Footer-module_footer__link__uHHqm a {\n  font-size: 16px;\n  color: #5b6473;\n  text-decoration: underline;\n}\n.Footer-module_footer__socialList__TJhC4 {\n  display: flex;\n  align-items: center;\n  column-gap: 14px;\n}\n@media (min-width: 1440px) {\n  .Footer-module_footer__socialList__TJhC4 {\n    justify-content: flex-end;\n  }\n}\n.Footer-module_footer__notesCol__B-zct {\n  grid-area: notes;\n}\n.Footer-module_footer__warning__CfPOt {\n  color: #5b6473;\n  font-size: 14px;\n  text-transform: uppercase;\n  margin-bottom: 14px;\n  font-weight: 500;\n}\n.Footer-module_footer__copyright__HVYbN {\n  color: #5b6473;\n  font-size: 14px;\n}";
var s$4 = {"footer":"Footer-module_footer__smP7p","footer__container":"Footer-module_footer__container__gjEa-","footer__logoCol":"Footer-module_footer__logoCol__R4QA6","footer__logo":"Footer-module_footer__logo__rQHjg","footer__titleCol":"Footer-module_footer__titleCol__10X1-","footer__title":"Footer-module_footer__title__4q4k8","footer__separator":"Footer-module_footer__separator__jIkdN","footer__linksCol":"Footer-module_footer__linksCol__X8dDz","footer__linksList":"Footer-module_footer__linksList__sgDTK","footer__link":"Footer-module_footer__link__uHHqm","footer__socialList":"Footer-module_footer__socialList__TJhC4","footer__notesCol":"Footer-module_footer__notesCol__B-zct","footer__warning":"Footer-module_footer__warning__CfPOt","footer__copyright":"Footer-module_footer__copyright__HVYbN"};
styleInject(css_248z$5);

var Footer = function () {
    var links = [
        {
            name: "Пользовательское соглашение",
            value: "".concat(config$1.policyUrl),
            event: "Д/ Нажал правила пользования сервисов / Подвал",
        },
        {
            name: "Карта сайта",
            value: "".concat(config$1.seoPartUrl, "/karta-sayta"),
            event: "Д/ Нажал на карту сайта / Подвал",
        },
        {
            name: "Сообщить о проблеме",
            value: "".concat(config$1.seoPartUrl, "/help"),
            event: "Д/ Нажал сообщить о проблеме / Подвал",
        },
    ];
    return (React.createElement("footer", { className: s$4.footer },
        React.createElement("div", { className: "screen-container" },
            React.createElement("div", { className: s$4.footer__container },
                React.createElement("div", { className: s$4.footer__logoCol },
                    React.createElement(Logo, { className: s$4.footer__logo })),
                React.createElement("div", { className: s$4.footer__titleCol },
                    React.createElement("p", { className: s$4.footer__title }, "\u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u043E\u0440\u0442\u0430\u043B \u0437\u0430\u043F\u0438\u0441\u0438 \u043A \u0432\u0440\u0430\u0447\u0443 \u0432 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0438 \u0447\u0430\u0441\u0442\u043D\u044B\u0435 \u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0441\u0442\u0440\u0430\u043D\u044B")),
                React.createElement("div", { className: s$4.footer__linksCol },
                    React.createElement("ul", { className: s$4.footer__linksList }, links.map(function (_a) {
                        var name = _a.name, value = _a.value, event = _a.event;
                        return (React.createElement("li", { key: name, className: s$4.footer__link },
                            React.createElement("a", { onClick: function () { return logLinkClick$1(event); }, href: value, target: "blank", className: "footer-menu__link" }, name)));
                    })),
                    React.createElement("ul", { className: s$4.footer__socialList },
                        React.createElement(SocialMediaIcons, { onClick: function () { return logLinkClick$1("Д/ Нажал на соц сети / Подвал"); } }))),
                React.createElement("div", { className: s$4.footer__notesCol },
                    React.createElement("div", { className: s$4.footer__separator }),
                    React.createElement("p", { className: s$4.footer__warning }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u0430\u044F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435, \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0430 \u0434\u043B\u044F \u043F\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438 \u0434\u0438\u0430\u0433\u043D\u043E\u0437\u0430, \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043B\u0435\u0447\u0435\u043D\u0438\u044F \u0438 \u043D\u0435 \u0437\u0430\u043C\u0435\u043D\u044F\u0435\u0442 \u043F\u0440\u0438\u0435\u043C \u0432\u0440\u0430\u0447\u0430."),
                    React.createElement("p", { className: s$4.footer__copyright },
                        "\u00A9 \u0418\u0421\u041F\u0414 \u201C\u0417\u0430\u043F\u0438\u0441\u044C \u043A \u0432\u0440\u0430\u0447\u0443\u201D ",
                        new Date().getFullYear(),
                        " \u041E\u041E\u041E \"\u041E\u043D\u043B\u0430\u0439\u043D \u0414\u043E\u0437\u043E\u0440\", 650000, \u0433. \u041A\u0435\u043C\u0435\u0440\u043E\u0432\u043E, \u0443\u043B. \u0420\u0430\u0434\u0438\u0449\u0435\u0432\u0430 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 2/2 \u041B\u0438\u0442\u0435\u0440 3 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435 3; \u0418\u041D\u041D 4205356421, \u041A\u041F\u041F 420501001, \u041E\u0413\u0420\u041D 1174205015203."))))));
};

var axios$2 = {exports: {}};

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$1 = bind$2;

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

var utils$h = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};

var utils$g = utils$h;

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$g.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$g.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$g.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$g.forEach(val, function parseValue(v) {
        if (utils$g.isDate(v)) {
          v = v.toISOString();
        } else if (utils$g.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$f = utils$h;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$f.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$e = utils$h;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$e.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

var utils$d = utils$h;

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError$5(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils$d.inherits(AxiosError$5, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError$5.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError$5, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError$5.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils$d.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError$5.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

var AxiosError_1 = AxiosError$5;

var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var utils$c = utils$h;

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData$1(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils$c.isDate(value)) {
      return value.toISOString();
    }

    if (utils$c.isArrayBuffer(value) || utils$c.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils$c.isPlainObject(data) || utils$c.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils$c.forEach(data, function each(value, key) {
        if (utils$c.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils$c.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils$c.endsWith(key, '[]') && (arr = utils$c.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils$c.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

var toFormData_1 = toFormData$1;

var AxiosError$4 = AxiosError_1;

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError$4(
      'Request failed with status code ' + response.status,
      [AxiosError$4.ERR_BAD_REQUEST, AxiosError$4.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};

var utils$b = utils$h;

var cookies$1 = (
  utils$b.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$b.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$b.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$b.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath$2 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

var utils$a = utils$h;

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils$a.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$a.trim(line.substr(0, i)).toLowerCase();
    val = utils$a.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var utils$9 = utils$h;

var isURLSameOrigin$1 = (
  utils$9.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils$9.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

var AxiosError$3 = AxiosError_1;
var utils$8 = utils$h;

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError$3(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError$3.call(this, message == null ? 'canceled' : message, AxiosError$3.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils$8.inherits(CanceledError$3, AxiosError$3, {
  __CANCEL__: true
});

var CanceledError_1 = CanceledError$3;

var parseProtocol$1 = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};

var utils$7 = utils$h;
var settle = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath$1 = buildFullPath$2;
var parseHeaders = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var transitionalDefaults$1 = transitional;
var AxiosError$2 = AxiosError_1;
var CanceledError$2 = CanceledError_1;
var parseProtocol = parseProtocol$1;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils$7.isFormData(requestData) && utils$7.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath$1(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError$2('Request aborted', AxiosError$2.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError$2('Network Error', AxiosError$2.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults$1;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError$2(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError$2.ETIMEDOUT : AxiosError$2.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$7.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$7.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError$2() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError$2('Unsupported protocol ' + protocol + ':', AxiosError$2.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};

// eslint-disable-next-line strict
var _null = null;

var utils$6 = utils$h;
var normalizeHeaderName = normalizeHeaderName$1;
var AxiosError$1 = AxiosError_1;
var transitionalDefaults = transitional;
var toFormData = toFormData_1;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$6.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$6.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$3 = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$6.isFormData(data) ||
      utils$6.isArrayBuffer(data) ||
      utils$6.isBuffer(data) ||
      utils$6.isStream(data) ||
      utils$6.isFile(data) ||
      utils$6.isBlob(data)
    ) {
      return data;
    }
    if (utils$6.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$6.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils$6.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils$6.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils$6.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: _null
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils$6.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});

utils$6.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$3;

var utils$5 = utils$h;
var defaults$2 = defaults_1;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$2;
  /*eslint no-param-reassign:0*/
  utils$5.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var utils$4 = utils$h;
var transformData = transformData$1;
var isCancel = isCancel$1;
var defaults$1 = defaults_1;
var CanceledError$1 = CanceledError_1;

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError$1();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$4.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$4.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

var utils$3 = utils$h;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source)) {
      return utils$3.merge(target, source);
    } else if (utils$3.isPlainObject(source)) {
      return utils$3.merge({}, source);
    } else if (utils$3.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils$3.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};

var data = {
  "version": "0.27.2"
};

var VERSION = data.version;
var AxiosError = AxiosError_1;

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator$1 = {
  assertOptions: assertOptions,
  validators: validators$1
};

var utils$2 = utils$h;
var buildURL = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var buildFullPath = buildFullPath$2;
var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils$2.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig$1(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios$1.prototype[method] = generateHTTPMethod();

  Axios$1.prototype[method + 'Form'] = generateHTTPMethod(true);
});

var Axios_1 = Axios$1;

var CanceledError = CanceledError_1;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

var utils$1 = utils$h;

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return utils$1.isObject(payload) && (payload.isAxiosError === true);
};

var utils = utils$h;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios;

// Expose Cancel & CancelToken
axios$1.CanceledError = CanceledError_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;
axios$1.toFormData = toFormData_1;

// Expose AxiosError class
axios$1.AxiosError = AxiosError_1;

// alias for CanceledError for backward compatibility
axios$1.Cancel = axios$1.CanceledError;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

axios$2.exports = axios$1;

// Allow use of default import syntax in TypeScript
axios$2.exports.default = axios$1;

var axios = axios$2.exports;

var css_248z$4 = ".Spinner-module_spinner__SZoUP {\n  position: relative;\n  display: flex;\n  width: 75px;\n  height: 75px;\n  align-items: center;\n  justify-content: center;\n}\n.Spinner-module_spinnerCircle__pca9j {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 4px solid transparent;\n  border-bottom: 0;\n  border-left: 0;\n  border-right: 0;\n  animation: Spinner-module_rotating__tMO2F 0.9s infinite linear;\n}\n.Spinner-module_spinnerLogo__ze5Y3 {\n  width: 45%;\n  height: 45%;\n}\n\n@keyframes Spinner-module_rotating__tMO2F {\n  0% {\n    transform: rotate(0deg);\n    border-color: rgba(255, 112, 112, 0.65);\n  }\n  25% {\n    transform: rotate(90deg);\n    border-color: #4794ff;\n  }\n  50% {\n    transform: rotate(180deg);\n    border-color: rgba(255, 112, 112, 0.65);\n  }\n  75% {\n    transform: rotate(270deg);\n    border-color: #4794ff;\n  }\n  100% {\n    transform: rotate(360deg);\n    border-color: rgba(255, 112, 112, 0.65);\n  }\n}";
var s$3 = {"spinner":"Spinner-module_spinner__SZoUP","spinnerCircle":"Spinner-module_spinnerCircle__pca9j","rotating":"Spinner-module_rotating__tMO2F","spinnerLogo":"Spinner-module_spinnerLogo__ze5Y3"};
styleInject(css_248z$4);

var Spinner = function () {
    return (React.createElement("div", { className: s$3.spinner },
        React.createElement("div", { className: s$3.spinnerCircle }),
        React.createElement("svg", { className: s$3.spinnerLogo, width: "63", height: "63", viewBox: "0 0 63 63", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M55.9251 28.2128C55.9251 31.8013 55.9251 35.3897 55.9251 38.9782C54.2956 38.6429 52.5138 38.6311 50.5651 38.974L50.5632 28.0851C50.5632 25.5851 44.0678 23.1892 40.0213 25.8414C37.9464 27.2015 38.1797 28.3162 38.1797 31.532V46.7241C38.1797 50.3754 38.3694 52.6876 35.4021 55.3086C31.9648 58.3447 26.5705 59.0739 22.1716 57.6257C18.0961 56.2839 15.2002 53.3179 15.2002 48.639C15.1998 44.714 15.1995 40.789 15.1992 36.864C16.8106 37.1701 18.5717 37.2166 20.5621 36.8645V49.0221C20.5621 51.7111 24.0526 52.9797 26.0516 52.9797C28.2837 52.9797 30.3045 52.8699 31.9587 51.2269C33.3608 49.8341 32.9456 48.6309 32.9456 45.9581C32.9456 43.7744 32.7698 28.5757 33.0582 27.1764C34.7764 18.8399 46.6695 17.4994 52.2799 21.7726C54.2307 23.2584 55.9252 25.4814 55.9252 28.2128L55.9251 28.2128Z", fill: "#FE515A" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.2649 8.68114C36.2649 11.8001 35.6877 12.5585 34.2763 14.863C33.3371 16.3964 26.2141 27.8279 25.4539 28.7649C21.4326 33.4383 14.8814 33.2978 10.7625 28.8217C8.15997 25.9196 3.78763 17.5868 1.23188 13.4577C-2.47309 7.47206 2.71044 0 9.71066 0C12.4239 0 13.1564 3.9406 10.6495 5.02416C9.91891 5.33995 5.60066 5.15005 5.40743 8.9622C5.30406 11.0009 12.8328 22.2916 14.2341 24.5841C16.3051 28.0522 20.1394 27.3014 21.639 25.0778C24.4729 20.5553 27.3141 16.0277 30.162 11.5149C31.9526 8.70159 30.5786 5.76412 27.1484 5.28654C26.0527 5.13399 25.726 5.18792 25.0571 4.56916C23.0475 2.70998 24.6992 0 26.69 0C31.5178 0 36.2649 3.68828 36.2649 8.68114Z", fill: "#FE515A" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M62.6896 52.7244C62.6896 54.6891 62.5793 55.5005 61.7539 57.1506C58.1412 64.3728 47.8101 64.2992 44.2176 57.1533C42.9858 54.7029 42.967 51.602 44.1752 49.1467C46.4776 44.4679 52.2664 42.3827 56.8171 44.4262C58.966 45.3911 60.6525 46.8513 61.7115 48.9789C62.2369 50.0345 62.6897 51.2011 62.6897 52.7244L62.6896 52.7244Z", fill: "#FE515A" }))));
};

var css_248z$3 = ".SearchInput-module_search__PUVy6 {\n  position: relative;\n  z-index: 1;\n  background-color: #d3e9f9;\n  padding-top: 22px;\n  padding-bottom: 22px;\n}\n@media (min-width: 768px) {\n  .SearchInput-module_search__PUVy6 {\n    background-color: transparent;\n    padding-top: 18px;\n    padding-bottom: 18px;\n  }\n}\n.SearchInput-module_searchIconWrap__9UZtJ {\n  display: none;\n}\n@media (min-width: 768px) {\n  .SearchInput-module_searchIconWrap__9UZtJ {\n    display: flex;\n    height: 100%;\n    position: absolute;\n    top: 0px;\n    left: 34px;\n    align-items: center;\n  }\n}\n.SearchInput-module_searchForm__VoZki {\n  position: relative;\n  margin-bottom: 0px;\n  display: flex;\n}\n.SearchInput-module_searchButtonWrap__wjsEV {\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  display: flex;\n  align-items: center;\n}\n@media (min-width: 768px) {\n  .SearchInput-module_searchButtonWrap__wjsEV {\n    right: 14px;\n  }\n}\n.SearchInput-module_searchButton__FAhDi {\n  background-color: #1874fd !important;\n  border-radius: 25px;\n  border: none;\n  width: 72px;\n  height: 50px;\n  transition: 0.2s ease-out;\n}\n@media (min-width: 768px) {\n  .SearchInput-module_searchButton__FAhDi {\n    width: 168px;\n    height: 50px;\n  }\n}\n.SearchInput-module_searchButton__FAhDi img {\n  margin-left: auto;\n  margin-right: auto;\n}\n@media (min-width: 768px) {\n  .SearchInput-module_searchButton__FAhDi img {\n    display: none;\n  }\n}\n.SearchInput-module_searchButton__FAhDi span {\n  display: none;\n}\n@media (min-width: 768px) {\n  .SearchInput-module_searchButton__FAhDi span {\n    display: block;\n    color: #ffffff;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n  }\n}\n.SearchInput-module_searchButton__FAhDi:hover {\n  background: #085fe2;\n  transition: 0.2s ease-out;\n}\n.SearchInput-module_searchInput__v28H1 {\n  padding: 15px 85px 15px 17px;\n  border-radius: 25px;\n  border: none;\n  color: #5b6473;\n  line-height: 20px;\n  width: 100%;\n}\n@media (min-width: 768px) {\n  .SearchInput-module_searchInput__v28H1 {\n    padding-left: 53px;\n    padding-right: 175px;\n    border-radius: 50px;\n    border: 15px solid #d3ebff;\n  }\n}";
var s$2 = {"search":"SearchInput-module_search__PUVy6","searchIconWrap":"SearchInput-module_searchIconWrap__9UZtJ","searchForm":"SearchInput-module_searchForm__VoZki","searchButtonWrap":"SearchInput-module_searchButtonWrap__wjsEV","searchButton":"SearchInput-module_searchButton__FAhDi","searchInput":"SearchInput-module_searchInput__v28H1"};
styleInject(css_248z$3);

var SearchInput = function (_a) {
    var onSubmit = _a.onSubmit, _b = _a.onChange, onChange = _b === void 0 ? function () { return ({}); } : _b, _c = _a.onBlur, onBlur = _c === void 0 ? function () { return ({}); } : _c;
    return (React.createElement("div", { className: s$2.search },
        React.createElement("div", { className: "screen-container" },
            React.createElement("form", { className: s$2.searchForm, onSubmit: onSubmit },
                React.createElement("div", { className: s$2.searchIconWrap },
                    React.createElement("img", { className: s$2.searchIcon, src: "https://onlinezdrav.ru/assets/location.svg", alt: "\u041C\u0430\u0440\u043A\u0435\u0440" })),
                React.createElement("input", { autoComplete: "off", name: "search-input", type: "text", className: "".concat(s$2.searchInput, " ").concat(s$2.searchLocation), placeholder: "\u0413\u043E\u0440\u043E\u0434", onChange: onChange, onBlur: onBlur }),
                React.createElement("div", { className: s$2.searchButtonWrap },
                    React.createElement("button", { type: "submit", className: s$2.searchButton },
                        React.createElement("img", { src: "https://onlinezdrav.ru/assets/search-icon-light.svg", alt: "\u041B\u0443\u043F\u0430" }),
                        React.createElement("span", null, "\u041D\u0410\u0419\u0422\u0418")))))));
};

axios.defaults.baseURL = config$1.api.endpoints.onlinezdrav;

const searchCity = async (query) => {
  return axios.get("/locality/search", {
    params: {
      search: query,
    },
  });
};

const fetchDefaultCities = async () => {
  return axios.get("/locality/default");
};

var logWindowOpened = function () {
    logEvent("М/ Окно выбора города", {});
};
var logSearchText = function (text) {
    logEvent("Д/ Ввел поиск города / Выбор города", {
        "Введенные данные": text,
    });
};
var logSearchSubmit = function (text) {
    logEvent("Д/ Нажал кнопку Найти в поиске города / Выбор города", {
        "Введенные данные": text,
    });
};
var logCitySelect = function (city) {
    logEvent("Д/ Выбрал город из списка / Выбор города", {
        "Выбранный город": city,
    });
};
var logWindowClosed = function () {
    logEvent("Д/ Закрыл Окно выбора города / Выбор города", {});
};

var css_248z$2 = ".Header-module_header__qxHtx {\n  background-color: #EBF4F8;\n  position: relative;\n  z-index: 10;\n  box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n@media (min-width: 768px) {\n  .Header-module_header__qxHtx {\n    box-shadow: none;\n    padding-top: 30px;\n    padding-bottom: 0px;\n  }\n}\n.Header-module_headerContainer__dRLtW {\n  grid-column: 1/-1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n.Header-module_headerLogoContainer__8trxr {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.Header-module_headerLogoContainer__8trxr > * {\n  margin-right: 50px;\n}\n.Header-module_headerLogoContainer__8trxr > *:last-child {\n  margin-right: 0px;\n}\n@media (min-width: 768px) {\n  .Header-module_headerLogoContainer__8trxr {\n    justify-content: flex-start;\n    margin-right: 8px;\n  }\n}\n.Header-module_headerButton__ktmk3 {\n  display: none;\n}\n@media (min-width: 768px) {\n  .Header-module_headerButton__ktmk3 {\n    display: flex;\n    margin-left: auto;\n    flex-shrink: 0;\n  }\n  .Header-module_headerButton__ktmk3 button {\n    padding: 10px;\n  }\n}\n@media (min-width: 1024px) {\n  .Header-module_headerButton__ktmk3 button {\n    padding: 12px 20px;\n  }\n}\n\n.Header-module_geolocationContainer__9agq3 {\n  align-items: center;\n  grid-column: span 8;\n}\n.Header-module_geolocationContainer__9agq3 > * {\n  margin-right: 16px;\n}\n.Header-module_geolocationContainer__9agq3 > *:last-child {\n  margin-right: 0px;\n}";
var s$1 = {"header":"Header-module_header__qxHtx","headerContainer":"Header-module_headerContainer__dRLtW","headerLogoContainer":"Header-module_headerLogoContainer__8trxr","headerButton":"Header-module_headerButton__ktmk3","geolocationContainer":"Header-module_geolocationContainer__9agq3"};
styleInject(css_248z$2);

var css_248z$1 = ".location {\n  position: relative;\n  width: fit-content;\n}\n.location__btn {\n  display: flex;\n  align-items: center;\n  border: none;\n}\n.location__city {\n  display: none;\n}\n@media (min-width: 768px) {\n  .location__city {\n    display: inline-block;\n    text-align: left;\n    font-size: 16px;\n    line-height: 1.1;\n    font-weight: 700;\n    color: #2d3748;\n    margin-left: 8px;\n  }\n}\n.location__city-loader {\n  display: none;\n}\n@media (min-width: 768px) {\n  .location__city-loader {\n    display: inline-block;\n    height: 20px;\n    width: 150px;\n    background-image: linear-gradient(90deg, #dce2e9 0px, #e8e8e8 40px, #dce2e9 80px);\n    background-size: 600px;\n    animation: shine-lines 1s infinite linear;\n    border-radius: 6px;\n    margin-left: 8px;\n  }\n  @keyframes shine-lines {\n    0% {\n      background-position: -100px;\n    }\n    40% {\n      background-position: 140px;\n    }\n    100% {\n      background-position: 140px;\n    }\n  }\n}\n\n.confirmation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  height: 100vh;\n  width: 100%;\n  left: 0;\n  top: 0;\n  z-index: 999;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n@media (min-width: 768px) {\n  .confirmation {\n    position: absolute;\n    height: auto;\n    background: none;\n    top: 32px;\n    justify-content: flex-start;\n  }\n}\n.confirmation__modal {\n  background: linear-gradient(0deg, #ffffff, #ffffff), #dcdcdc;\n  box-shadow: 0px 4px 5px rgba(3, 28, 65, 0.25);\n  padding: 15px 18px;\n  border-radius: 7px;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 768px) {\n  .confirmation__modal {\n    padding: 15px 24px;\n    width: max-content;\n  }\n}\n.confirmation__title {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #5b6473;\n  padding-bottom: 5px;\n}\n.confirmation__city {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 25px;\n  color: #2d3748;\n}\n.confirmation__controls {\n  display: flex;\n  margin-top: 10px;\n  column-gap: 10px;\n  font-size: 14px;\n}\n\n.city-modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  height: 100vh;\n  width: 100%;\n  left: 0;\n  top: 0;\n  z-index: 999;\n}\n.city-modal__overlay {\n  background-color: rgba(0, 0, 0, 0.2);\n  position: fixed;\n  height: 100vh;\n  width: 100%;\n  left: 0;\n  top: 0;\n}\n.city-modal__window {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background-color: white;\n  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);\n}\n@media (min-width: 768px) {\n  .city-modal__window {\n    top: auto;\n    left: auto;\n    max-width: 800px;\n    height: auto;\n    overflow: initial;\n    border-radius: 10px;\n  }\n}\n@media (min-width: 768px) {\n  .city-modal__title-row {\n    background-color: transparent !important;\n  }\n}\n@media (min-width: 768px) {\n  .city-modal__close {\n    border-radius: 50%;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n    padding: 10px;\n    position: absolute;\n    right: -10px;\n    top: -10px;\n    z-index: 9999;\n    background-color: white;\n    border: none;\n  }\n}\n.city-modal__title-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.city-modal__loader-wrap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 30px 0px;\n}\n.city-modal__city-list {\n  padding: 20px 0px;\n  overflow-y: auto;\n  max-height: 400px;\n}\n@media (min-width: 768px) {\n  .city-modal__city-list {\n    padding-top: 0px;\n  }\n}\n.city-modal__city {\n  border: 2px solid transparent;\n  border-radius: 7px;\n  padding: 6px 10px;\n  color: #5b6473;\n  cursor: pointer;\n}\n.city-modal__city:hover {\n  border: 2px solid #2ad966;\n}\n.city-modal__city a {\n  width: 100%;\n  display: block;\n}\n.city-modal__notfound {\n  color: #f56565;\n  padding-top: 16px;\n  padding-bottom: 32px;\n  text-align: center;\n}";
styleInject(css_248z$1);

var Confirmation = function (_a) {
    var city = _a.city, accept = _a.accept, decline = _a.decline;
    return (React.createElement("div", { className: "confirmation" },
        React.createElement("div", { className: "screen-container" },
            React.createElement("div", { className: "confirmation__modal" },
                React.createElement("p", { className: "confirmation__title" }, "\u0412\u044B \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0435\u0441\u044C"),
                React.createElement("span", { className: "confirmation__city" }, city),
                React.createElement("div", { className: "confirmation__controls" },
                    React.createElement("button", { type: "button", className: "button", onClick: accept }, "\u0414\u0430, \u0432\u0435\u0440\u043D\u043E"),
                    React.createElement("button", { type: "button", className: "button button--outlined", onClick: decline }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439"))))));
};
var UserLocation = function (_a) {
    var _b = _a.cityModel, cityModel = _b === void 0 ? null : _b, _c = _a.onLocationChange, onLocationChange = _c === void 0 ? function () { } : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d;
    var _e = useState([]), defaultCities = _e[0], setDefaultCities = _e[1];
    var _f = useState([]), cities = _f[0], setCities = _f[1];
    var _g = useState(null), currentCity = _g[0], setCurrentCity = _g[1];
    var _h = useState(null), defaultCity = _h[0], setDefaultCity = _h[1];
    var _j = useState(false), isLoading = _j[0], setLoadingStatus = _j[1];
    var _k = useState(false), isConfirmationVisible = _k[0], setConfirmationStatus = _k[1];
    var _l = useState(false), isModalVisible = _l[0], setModalStatus = _l[1];
    var currentCityString = useMemo(function () {
        if (!currentCity) {
            return "";
        }
        return currentCity.area_name.replace("г. ", "") === currentCity.name
            ? currentCity.name
            : "".concat(currentCity.name, " (").concat(currentCity.area_name, ")");
    }, [currentCity]);
    var handleSetCurrentCity = function (city) {
        if (!city) {
            return;
        }
        localStorage.setItem("currentCity", JSON.stringify(city));
        setCurrentCity(city);
        onLocationChange(city);
    };
    var showModal = function () {
        setModalStatus(true);
        logWindowOpened();
    };
    var clickActivator = function () {
        showModal();
        onClick();
    };
    var resetCities = function () {
        setCities(defaultCities);
    };
    var hideModal = function () {
        setModalStatus(false);
        resetCities();
        logWindowClosed();
    };
    var clickCity = function (event, city) {
        logCitySelect(city.name);
        if (!config$1.isSPA) {
            return;
        }
        event.preventDefault();
        handleSetCurrentCity(city);
        hideModal();
    };
    var getUserCoords = function () {
        if (!navigator.geolocation) {
            throw new Error("Браузер не поддерживает определение местоположения");
        }
        return new Promise(function (resolve, reject) {
            // eslint-disable-next-line no-promise-executor-return
            return navigator.geolocation.getCurrentPosition(resolve, reject);
        });
    };
    var detectCityByLocation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var coords, _a, latitude, longitude, data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, getUserCoords()];
                case 1:
                    coords = _b.sent();
                    _a = coords.coords, latitude = _a.latitude, longitude = _a.longitude;
                    return [4 /*yield*/, axios.get("https://geocode-maps.yandex.ru/1.x/?format=json&apikey=".concat(config$1.yandexGeocoderApiKey, "&geocode=").concat(longitude, ",").concat(latitude, "&lang=ru_RU&kind=house"))];
                case 2:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data.response.GeoObjectCollection.featureMember[0].GeoObject.metaDataProperty.GeocoderMetaData.Address.Components.find(function (item) { return item.kind === "locality"; }).name];
                case 3:
                    error_1 = _b.sent();
                    console.error("Ошибка определения города", error_1);
                    return [2 /*return*/, "Москва"];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var assumeCity = function (query) { return __awaiter(void 0, void 0, void 0, function () {
        var searchResults, possibleCity;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, searchCity(query)];
                case 1:
                    searchResults = _c.sent();
                    possibleCity = (_b = (_a = searchResults.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0];
                    if (!possibleCity && defaultCity) {
                        return [2 /*return*/, handleSetCurrentCity(defaultCity)];
                    }
                    handleSetCurrentCity(possibleCity);
                    return [2 /*return*/, setConfirmationStatus(true)];
            }
        });
    }); };
    var detectUserCity = function () { return __awaiter(void 0, void 0, void 0, function () {
        var urlParams, city;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (cityModel) {
                        return [2 /*return*/, handleSetCurrentCity(cityModel)];
                    }
                    urlParams = new URLSearchParams(window.location.search);
                    if (!urlParams.has("city")) return [3 /*break*/, 2];
                    return [4 /*yield*/, assumeCity(urlParams.get("city"))];
                case 1:
                    _b.sent();
                    return [2 /*return*/, true];
                case 2:
                    if (localStorage.getItem("currentCity") &&
                        localStorage.getItem("currentCity") !== "null" &&
                        localStorage.getItem("currentCity") !== "undefined") {
                        return [2 /*return*/, handleSetCurrentCity(JSON.parse((_a = localStorage.getItem("currentCity")) !== null && _a !== void 0 ? _a : "null"))];
                    }
                    return [4 /*yield*/, detectCityByLocation()];
                case 3:
                    city = _b.sent();
                    return [4 /*yield*/, assumeCity(city)];
                case 4:
                    _b.sent();
                    return [2 /*return*/, true];
            }
        });
    }); };
    var confirmCity = function () {
        setConfirmationStatus(false);
    };
    var handleFormSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var query, response, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    event.preventDefault();
                    query = (_a = event.target.elements["search-input"].value.toLowerCase()) !== null && _a !== void 0 ? _a : "";
                    if (!query) {
                        return [2 /*return*/, resetCities()];
                    }
                    logSearchSubmit(query);
                    setLoadingStatus(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, searchCity(query)];
                case 2:
                    response = _b.sent();
                    setCities(response.data.data);
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _b.sent();
                    console.error(error_2);
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingStatus(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/, true];
            }
        });
    }); };
    var onSearchBlur = function (event) {
        logSearchText(event.target.value);
    };
    var clearOldLocalStorageValues = function () {
        localStorage.removeItem("usersCity");
        localStorage.removeItem("usersArea");
        localStorage.removeItem("slugUrl");
        localStorage.removeItem("region");
        localStorage.removeItem("currentRegion");
    };
    useEffect(function () {
        var onMounted = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clearOldLocalStorageValues(); // временно, чтобы почистить от старых значений
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, fetchDefaultCities()];
                    case 2:
                        response = _a.sent();
                        setDefaultCities(response.data.data);
                        setCities(response.data.data);
                        setDefaultCity(response.data.data[0]);
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _a.sent();
                        console.error(error_3);
                        return [3 /*break*/, 5];
                    case 4:
                        detectUserCity();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        onMounted();
    }, []);
    return (React.createElement("div", { className: "" },
        React.createElement("div", { className: "location" },
            React.createElement("button", { type: "button", className: "location__btn", onClick: clickActivator },
                React.createElement("img", { src: "https://onlinezdrav.ru/assets/location.svg", alt: "\u041C\u0430\u0440\u043A\u0435\u0440" }),
                currentCityString ? (React.createElement("span", { className: "location__city" }, currentCityString)) : (React.createElement("span", { className: "location__city-loader" }))),
            isConfirmationVisible && (React.createElement(Confirmation, { city: currentCityString, accept: confirmCity, decline: showModal }))),
        isModalVisible && (React.createElement("div", { className: "city-modal" },
            React.createElement("div", { className: "city-modal__overlay" }),
            React.createElement("div", { className: "city-modal__window" },
                React.createElement("div", { className: "".concat(s$1.header, " city-modal__title-row") },
                    React.createElement("div", { className: "screen-container city-modal__title-wrap" },
                        React.createElement("div", { className: "headline-2 city-modal__title" }, "\u0412\u0430\u0448 \u0433\u043E\u0440\u043E\u0434"),
                        React.createElement("button", { type: "button", className: "city-modal__close", onClick: hideModal },
                            React.createElement("img", { className: "", src: "https://onlinezdrav.ru/assets/close-icon.svg", alt: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C" })))),
                React.createElement("div", { className: "city-modal__search" },
                    React.createElement(SearchInput, { onSubmit: handleFormSubmit, onBlur: onSearchBlur })),
                React.createElement("div", { className: "screen-container" },
                    isLoading && (React.createElement("div", { className: "city-modal__loader-wrap" },
                        React.createElement(Spinner, null))),
                    !isLoading && cities.length === 0 && (React.createElement("div", { className: "city-modal__notfound" }, "\u0413\u043E\u0440\u043E\u0434 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D")),
                    !isLoading && cities.length !== 0 && (React.createElement("ul", { className: "city-modal__city-list" }, cities.map(function (city) { return (React.createElement("li", { key: city.slug, className: "city-modal__city" },
                        React.createElement("a", { onClick: function (event) { return clickCity(event, city); }, href: "/".concat(city.slug, "/spisok-mo") }, city.default
                            ? city.name
                            : "".concat(city.name, " (").concat(city.area_name, ")")))); })))))))));
};

/* eslint-disable import/prefer-default-export */
var logLinkClick = function (event) {
    logEvent(event, {});
};

var css_248z = ".Menu-module_mobileMenu__IbxJT {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  z-index: 12;\n  left: 0;\n  top: 0;\n}\n.Menu-module_mobileMenuWrapper__GYDpN {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-top: 40px;\n  padding-bottom: 40px;\n  height: 100%;\n  width: 100%;\n}\n.Menu-module_mobileMenuLinksContainer__nkG-p {\n  display: flex;\n  flex-direction: column;\n  row-gap: 20px;\n}\n.Menu-module_mobileMenuButtonContainer__hrucy {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n}\n.Menu-module_mobileMenuSocialMedia__jiVtq {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.Menu-module_mobileMenuBar__gnSFG {\n  position: fixed;\n  z-index: 8;\n  left: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.97);\n  border-top: 2px solid #e5e7eb;\n  width: 100vw;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n@media (min-width: 1024px) {\n  .Menu-module_mobileMenuBar__gnSFG {\n    display: none;\n  }\n}\n.Menu-module_mobileMenuBarItem__njen0 {\n  font-size: 10px;\n  color: #2D3748;\n  text-decoration: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 8px 18px;\n  font-weight: 500;\n  color: #91a5bc;\n}\n.Menu-module_mobileMenuBarItemActive__rKsTA {\n  color: #1874fd !important;\n}\n.Menu-module_mobileMenuBarItem__njen0 svg {\n  margin-bottom: 2px;\n  height: 24px;\n}\n\n.Menu-module_desktopMenu__W4tiv {\n  grid-column: 1/-1;\n  display: none;\n}\n@media (min-width: 768px) {\n  .Menu-module_desktopMenu__W4tiv {\n    display: block;\n    padding-top: 22px;\n    padding-bottom: 10px;\n  }\n}\n.Menu-module_desktopMenuList__oZcqx {\n  display: flex;\n}\n.Menu-module_desktopMenuItem__oRO1w {\n  margin-right: 32px;\n}\n.Menu-module_desktopMenuLink__ljLn3 {\n  font-weight: 500;\n  font-size: 14px;\n  letter-spacing: 0.04em;\n  color: #2d3748;\n  text-transform: uppercase;\n  transition: 0.2s ease-out;\n}\n.Menu-module_desktopMenuLinkActive__HBcF5 {\n  color: #1874fd !important;\n}\n.Menu-module_desktopMenuLink__ljLn3:hover {\n  color: #1874FD;\n}";
var s = {"mobileMenu":"Menu-module_mobileMenu__IbxJT","mobileMenuWrapper":"Menu-module_mobileMenuWrapper__GYDpN","mobileMenuLinksContainer":"Menu-module_mobileMenuLinksContainer__nkG-p","mobileMenuButtonContainer":"Menu-module_mobileMenuButtonContainer__hrucy","mobileMenuSocialMedia":"Menu-module_mobileMenuSocialMedia__jiVtq","mobileMenuBar":"Menu-module_mobileMenuBar__gnSFG","mobileMenuBarItem":"Menu-module_mobileMenuBarItem__njen0","mobileMenuBarItemActive":"Menu-module_mobileMenuBarItemActive__rKsTA","desktopMenu":"Menu-module_desktopMenu__W4tiv","desktopMenuList":"Menu-module_desktopMenuList__oZcqx","desktopMenuItem":"Menu-module_desktopMenuItem__oRO1w","desktopMenuLink":"Menu-module_desktopMenuLink__ljLn3","desktopMenuLinkActive":"Menu-module_desktopMenuLinkActive__HBcF5"};
styleInject(css_248z);

var MobileMenu = function (_a) {
    var onClose = _a.onClose;
    var links = [
        {
            name: "О сервисе",
            value: "".concat(config$1.seoPartUrl, "/about"),
        },
        { name: "Сообщить о проблеме", value: "".concat(config$1.seoPartUrl, "/help") },
        {
            name: "Правила пользования сервисом",
            value: "".concat(config$1.policyUrl),
        },
        {
            name: "Пользовательское соглашение",
            value: "".concat(config$1.policyUrl),
        },
    ];
    var handleAssign = function () { };
    return (React.createElement("div", { className: s.mobileMenu },
        React.createElement("header", { className: s$1.header },
            React.createElement("div", { className: "screen-container" },
                React.createElement("div", { className: s$1.headerContainer },
                    React.createElement("div", { className: s$1.headerLogoContainer },
                        React.createElement(Logo, null)),
                    React.createElement("button", { type: "button", onClick: onClose },
                        React.createElement("img", { alt: "\u041A\u0440\u0435\u0441\u0442\u0438\u043A", src: "https://onlinezdrav.ru/assets/close-icon.svg" }))))),
        React.createElement("div", { className: "screen-container ".concat(s.mobileMenuWrapper) },
            React.createElement("nav", { className: s.mobileMenuLinksContainer }, links.map(function (_a) {
                var name = _a.name, value = _a.value;
                return (React.createElement("a", { href: value, key: name + value }, name));
            })),
            React.createElement("div", { className: s.mobileMenuButtonContainer },
                React.createElement("button", { type: "button", className: "button", onClick: handleAssign }, "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u043F\u0440\u0438\u0435\u043C"),
                React.createElement("div", { className: s.mobileMenuSocialMedia },
                    React.createElement(SocialMediaIcons, null))))));
};
var MobileIcons = function (_a) {
    var iconType = _a.iconType;
    var determinateSVGIcon = useCallback(function () {
        switch (iconType) {
            case "organizations":
                return (React.createElement("svg", { width: "29", height: "26", viewBox: "0 0 29 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("mask", { id: "path-1-inside-1_1455_111", fill: "white" },
                        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.404 2.08008C11.2995 2.08008 10.404 2.97551 10.404 4.08008V9.0689L5.125 9.0689C4.02043 9.0689 3.125 9.96433 3.125 11.0689L3.125 14.9313C3.125 16.0359 4.02043 16.9313 5.125 16.9313H10.404V21.9201C10.404 23.0246 11.2995 23.9201 12.404 23.9201H16.594C17.6986 23.9201 18.594 23.0247 18.594 21.9201V16.9313H23.875C24.9796 16.9313 25.875 16.0359 25.875 14.9313V11.0689C25.875 9.96434 24.9796 9.0689 23.875 9.0689L18.594 9.0689V4.08008C18.594 2.97551 17.6986 2.08008 16.594 2.08008H12.404Z" })),
                    React.createElement("path", { d: "M10.404 9.0689L10.404 11.0689L12.404 11.0689V9.0689H10.404ZM5.125 9.0689L5.125 7.0689H5.125V9.0689ZM3.125 11.0689H5.125H3.125ZM3.125 14.9313H5.125H3.125ZM10.404 16.9313H12.404V14.9313H10.404V16.9313ZM18.594 16.9313V14.9313H16.594V16.9313H18.594ZM23.875 9.0689V11.0689V9.0689ZM18.594 9.0689H16.594V11.0689H18.594V9.0689ZM12.404 4.08008V4.08008V0.0800781C10.1949 0.0800781 8.40404 1.87093 8.40404 4.08008H12.404ZM12.404 9.0689V4.08008H8.40404V9.0689H12.404ZM5.125 11.0689H10.404L10.404 7.0689L5.125 7.0689L5.125 11.0689ZM5.125 11.0689V11.0689V7.0689C2.91586 7.0689 1.125 8.85977 1.125 11.0689H5.125ZM5.125 14.9313L5.125 11.0689H1.125L1.125 14.9313H5.125ZM5.125 14.9313H5.125H1.125C1.125 17.1404 2.91586 18.9313 5.125 18.9313V14.9313ZM10.404 14.9313H5.125V18.9313H10.404V14.9313ZM12.404 21.9201V16.9313H8.40404V21.9201H12.404ZM12.404 21.9201H8.40404C8.40404 24.1292 10.1949 25.9201 12.404 25.9201V21.9201ZM16.594 21.9201H12.404V25.9201H16.594V21.9201ZM16.594 21.9201V21.9201V25.9201C18.8032 25.9201 20.594 24.1292 20.594 21.9201H16.594ZM16.594 16.9313V21.9201H20.594V16.9313H16.594ZM23.875 14.9313H18.594V18.9313H23.875V14.9313ZM23.875 14.9313V14.9313V18.9313C26.0841 18.9313 27.875 17.1404 27.875 14.9313H23.875ZM23.875 11.0689V14.9313H27.875V11.0689H23.875ZM23.875 11.0689H27.875C27.875 8.85977 26.0841 7.0689 23.875 7.0689V11.0689ZM18.594 11.0689L23.875 11.0689V7.0689L18.594 7.0689V11.0689ZM16.594 4.08008V9.0689H20.594V4.08008H16.594ZM16.594 4.08008V4.08008H20.594C20.594 1.87094 18.8032 0.0800781 16.594 0.0800781V4.08008ZM12.404 4.08008H16.594V0.0800781H12.404V4.08008Z", fill: "currentColor", mask: "url(#path-1-inside-1_1455_111)" })));
            case "support":
                return (React.createElement("svg", { width: "29", height: "26", viewBox: "0 0 29 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.4141 4.0475C9.30974 4.0475 5.17188 8.01985 5.17188 12.92C5.17188 17.8202 9.30974 21.7925 14.4141 21.7925C19.5185 21.7925 23.6562 17.8202 23.6562 12.92C23.6562 8.01985 19.5185 4.0475 14.4141 4.0475ZM3.03906 12.92C3.03906 6.88905 8.13182 2 14.4141 2C20.6963 2 25.7891 6.88905 25.7891 12.92C25.7891 18.951 20.6963 23.84 14.4141 23.84C8.13182 23.84 3.03906 18.951 3.03906 12.92ZM15.8359 17.015C15.8359 17.7689 15.1994 18.38 14.4141 18.38C13.6288 18.38 12.9922 17.7689 12.9922 17.015C12.9922 16.2611 13.6288 15.65 14.4141 15.65C15.1994 15.65 15.8359 16.2611 15.8359 17.015ZM12.8796 10.3066C12.9941 10.0868 13.149 9.89812 13.3615 9.76213C13.5674 9.6304 13.8897 9.5075 14.4141 9.5075C14.8118 9.5075 15.2002 9.62565 15.4627 9.81462C15.6967 9.98309 15.8359 10.2038 15.8359 10.5312C15.8359 10.7723 15.7779 10.8913 15.7262 10.9658C15.6617 11.0587 15.5505 11.1614 15.3332 11.3004C15.2246 11.3699 15.1078 11.4375 14.9651 11.5197L14.9564 11.5247C14.8231 11.6014 14.6658 11.6921 14.5112 11.791C14.1952 11.9933 13.8177 12.2745 13.5267 12.6936C13.2001 13.164 13.3325 13.7996 13.8226 14.1132C14.3126 14.4268 14.9747 14.2997 15.3014 13.8292C15.3659 13.7363 15.4771 13.6336 15.6944 13.4946C15.803 13.4251 15.9198 13.3575 16.0625 13.2753L16.0713 13.2702C16.2045 13.1935 16.3618 13.1029 16.5164 13.004C16.8323 12.8018 17.2099 12.5206 17.5008 12.1015C17.8047 11.6641 17.9688 11.1433 17.9688 10.5312C17.9688 9.49373 17.4563 8.69066 16.7424 8.17662C16.0569 7.6831 15.2012 7.46 14.4141 7.46C13.5165 7.46 12.7725 7.67835 12.1785 8.0585C11.5912 8.43438 11.2129 8.92822 10.972 9.39091C10.7086 9.89662 10.9221 10.5116 11.4489 10.7644C11.9756 11.0173 12.6162 10.8123 12.8796 10.3066Z", fill: "currentColor" })));
            case "menu":
                return (React.createElement("svg", { width: "29", height: "26", viewBox: "0 0 29 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.125 5.24537C3.125 4.95756 3.25341 4.68152 3.48196 4.47801C3.71052 4.27449 4.02052 4.16016 4.34375 4.16016H24.6562C24.9795 4.16016 25.2895 4.27449 25.518 4.47801C25.7466 4.68152 25.875 4.95756 25.875 5.24537C25.875 5.53319 25.7466 5.80922 25.518 6.01274C25.2895 6.21625 24.9795 6.33059 24.6562 6.33059H4.34375C4.02052 6.33059 3.71052 6.21625 3.48196 6.01274C3.25341 5.80922 3.125 5.53319 3.125 5.24537ZM3.125 12.4802C3.125 12.1923 3.25341 11.9163 3.48196 11.7128C3.71052 11.5093 4.02052 11.3949 4.34375 11.3949H24.6562C24.9795 11.3949 25.2895 11.5093 25.518 11.7128C25.7466 11.9163 25.875 12.1923 25.875 12.4802C25.875 12.768 25.7466 13.044 25.518 13.2475C25.2895 13.451 24.9795 13.5654 24.6562 13.5654H4.34375C4.02052 13.5654 3.71052 13.451 3.48196 13.2475C3.25341 13.044 3.125 12.768 3.125 12.4802ZM4.34375 18.6297C4.02052 18.6297 3.71052 18.744 3.48196 18.9476C3.25341 19.1511 3.125 19.4271 3.125 19.7149C3.125 20.0027 3.25341 20.2788 3.48196 20.4823C3.71052 20.6858 4.02052 20.8002 4.34375 20.8002H24.2992C24.6224 20.8002 24.9325 20.6858 25.161 20.4823C25.3896 20.2788 25.518 20.0027 25.518 19.7149C25.518 19.4271 25.3896 19.1511 25.161 18.9476C24.9325 18.744 24.6224 18.6297 24.2992 18.6297H4.34375Z", fill: "currentColor" })));
            default:
                return "";
        }
    }, [iconType]);
    return React.createElement(React.Fragment, null, determinateSVGIcon());
};
var Menu = function (_a) {
    var _b = _a.citySlug, citySlug = _b === void 0 ? "moskva" : _b;
    var _c = useState(false), isMobileMenuOpen = _c[0], setMobileMenuStatus = _c[1];
    var navLinks = [
        {
            title: "Медицинские организации",
            href: config$1.isSPA
                ? "".concat(config$1.seoPartUrl, "/").concat(citySlug, "/spisok-mo")
                : "/".concat(citySlug, "/spisok-mo"),
            event: "Д/ Нажал раздел Медицинские организации / Хедер",
        },
        {
            title: "Помощь",
            href: config$1.isSPA ? "".concat(config$1.seoPartUrl, "/help") : "/help",
            event: "Д/ Нажал раздел Помощь / Хедер",
        },
        {
            title: "О сервисе",
            href: config$1.isSPA ? "".concat(config$1.seoPartUrl, "/about") : "/about",
            event: "Д/ Нажал раздел О сервисе / Хедер",
        },
    ];
    var mobileNavLinks = [
        {
            title: "Организации",
            href: config$1.isSPA
                ? "".concat(config$1.seoPartUrl, "/").concat(citySlug, "/spisok-mo")
                : "/".concat(citySlug, "/spisok-mo"),
            icon: "organizations",
        },
        {
            title: "Помощь",
            href: config$1.isSPA ? "".concat(config$1.seoPartUrl, "/help") : "/help",
            icon: "support",
        },
    ];
    var handlerOpenMenu = function () {
        setMobileMenuStatus(true);
    };
    var isActiveLink = function (href) {
        if (config$1.isSPA && href.includes("spisok")) {
            return true;
        }
        return (window.location.pathname.length > 1 &&
            href.includes(window.location.pathname));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("nav", { className: s.desktopMenu },
            React.createElement("ul", { className: s.desktopMenuList }, navLinks.map(function (link) { return (React.createElement("li", { className: s.desktopMenuItem, key: link.title },
                React.createElement("a", { onClick: function () { return logLinkClick(link.event); }, className: s.desktopMenuLink +
                        (isActiveLink(link.href) ? " ".concat(s.desktopMenuLinkActive) : ""), href: link.href }, link.title))); }))),
        React.createElement("nav", { className: s.mobileMenuBar },
            mobileNavLinks.map(function (link) { return (React.createElement("a", { className: s.mobileMenuBarItem +
                    (isActiveLink(link.href) ? " ".concat(s.mobileMenuBarItemActive) : ""), href: link.href, key: link.title },
                React.createElement(MobileIcons, { iconType: link.icon }),
                link.title)); }),
            React.createElement("button", { type: "button", className: s.mobileMenuBarItem, onClick: handlerOpenMenu },
                React.createElement(MobileIcons, { iconType: "menu" }),
                "\u041C\u0435\u043D\u044E")),
        isMobileMenuOpen && (React.createElement(MobileMenu, { onClose: function () { return setMobileMenuStatus(false); } }))));
};

var logLogoClick = function () {
    logEvent("Д/ Нажал эмблему сайта / Хедер", {});
};
var logRegisterBtnClick = function () {
    logEvent("Д/ Нажал кнопку Записаться к врачу / Хедер", {});
};
var logCitySelectorClick = function () {
    logEvent("Д/ Нажал смену региона / Хедер", {});
};

var Header = function (_a) {
    var _b;
    var _c = _a.cityModel, cityModel = _c === void 0 ? null : _c, _d = _a.onLocationChange, onLocationChange = _d === void 0 ? function () { } : _d;
    var _e = useState(cityModel ||
        JSON.parse(((_b = localStorage.getItem("currentCity")) !== null && _b !== void 0 ? _b : "null").replace("undefined", "null"))), city = _e[0], setCity = _e[1];
    var appUrl = useMemo(function () {
        return config$1.isSPA
            ? "/login"
            : "".concat(config$1.reactivePartUrl, "/login").concat(city ? "?city=".concat(encodeURIComponent(city.name)) : "");
    }, [city]);
    useEffect(function () {
        if (localStorage.getItem("currentCity") &&
            (localStorage.getItem("currentCity") === "null" ||
                localStorage.getItem("currentCity") === "undefined")) {
            localStorage.removeItem("currentCity");
        }
    }, []);
    var handleLocationChange = function (_city) {
        setCity(_city);
        onLocationChange(_city);
    };
    return (React.createElement("header", { className: s$1.header },
        React.createElement("div", { className: "screen-container" },
            React.createElement("div", { className: s$1.headerContainer },
                React.createElement("div", { className: s$1.headerLogoContainer },
                    React.createElement(Logo, { onClick: logLogoClick }),
                    React.createElement(UserLocation, { onClick: logCitySelectorClick, onLocationChange: handleLocationChange, cityModel: cityModel })),
                React.createElement("div", { className: s$1.headerButton },
                    React.createElement("a", { onClick: logRegisterBtnClick, href: appUrl, className: "button" }, "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u043F\u0440\u0438\u0435\u043C"))),
            React.createElement(Menu, { citySlug: city === null || city === void 0 ? void 0 : city.slug }))));
};

export { Footer, Header, SearchInput, Spinner };
